// App Promotion — admin-controlled Get the App banner rules (pure helpers).
export const PROMO_DEFAULTS = { banner_enabled: true, frequency: "per_visit", dismiss_duration: "next_visit" };

export const FREQUENCY_OPTIONS = [
  { value: "per_visit", label: "Once per visit" },
  { value: "per_day", label: "Once per day" },
  { value: "every_5m", label: "Timed reminder — every 5 minutes" },
  { value: "every_15m", label: "Timed reminder — every 15 minutes" },
  { value: "every_30m", label: "Timed reminder — every 30 minutes" },
];

export const DISMISS_OPTIONS = [
  { value: "next_visit", label: "Until the next visit" },
  { value: "24h", label: "24 hours" },
  { value: "30d", label: "30 days" },
];

// Existing session key kept so earlier dismissals still count.
export const KEYS = {
  sessionDismissed: "rgm_get_app_banner_dismissed_v1",
  sessionShown: "rgm_app_promo_session_shown",
  dismissedUntil: "rgm_app_promo_dismissed_until",
  lastShown: "rgm_app_promo_last_shown",
};

const DAY = 24 * 60 * 60 * 1000;
const DISMISS_MS = { next_visit: 0, "24h": DAY, "30d": 30 * DAY };
const TIMED_MS = { every_5m: 5 * 60000, every_15m: 15 * 60000, every_30m: 30 * 60000 };

export const normalizePromo = (s) => {
  const o = { ...PROMO_DEFAULTS, ...(s || {}) };
  if (!FREQUENCY_OPTIONS.some((x) => x.value === o.frequency)) o.frequency = PROMO_DEFAULTS.frequency;
  if (!DISMISS_OPTIONS.some((x) => x.value === o.dismiss_duration)) o.dismiss_duration = PROMO_DEFAULTS.dismiss_duration;
  o.banner_enabled = o.banner_enabled !== false;
  return o;
};

const get = (store, k) => { try { return store.getItem(k); } catch { return null; } };
const set = (store, k, v) => { try { store.setItem(k, v); } catch { /* storage blocked */ } };

// Is the banner allowed to appear right now?
export const isBannerDue = (settings, now, session, local) => {
  const s = normalizePromo(settings);
  if (!s.banner_enabled) return false;
  if (Number(get(local, KEYS.dismissedUntil) || 0) > now) return false;
  const timed = !!TIMED_MS[s.frequency];
  if (!timed && get(session, KEYS.sessionDismissed) === "1") return false;
  if (s.frequency === "per_day" && get(session, KEYS.sessionShown) !== "1") {
    const last = Number(get(local, KEYS.lastShown) || 0);
    if (last && now - last < DAY) return false;
  }
  return true;
};

export const markBannerShown = (settings, now, session, local) => {
  if (get(session, KEYS.sessionShown) !== "1") {
    set(session, KEYS.sessionShown, "1");
    if (normalizePromo(settings).frequency === "per_day") set(local, KEYS.lastShown, String(now));
  }
};

// Timed reminders snooze for their interval (or the longer dismissal);
// otherwise "next visit" is session-scoped and 24h/30d are persistent.
export const dismissBanner = (settings, now, session, local) => {
  const s = normalizePromo(settings);
  const timed = TIMED_MS[s.frequency];
  const dur = DISMISS_MS[s.dismiss_duration];
  if (timed) set(local, KEYS.dismissedUntil, String(now + Math.max(timed, dur)));
  else if (dur) set(local, KEYS.dismissedUntil, String(now + dur));
  else set(session, KEYS.sessionDismissed, "1");
};

// No new banner pop-ups during contests or while music/video plays.
export const isQuietMoment = (path) => {
  if (/^\/contests?(\/|$)/.test(path || "")) return true;
  try {
    return [...document.querySelectorAll("audio,video")].some((m) => !m.paused && !m.ended);
  } catch {
    return false;
  }
};
